<ng-container *ngIf="scenariosDependencies$ | async as scenariosDependencies">
  <div *ngIf="scenariosDependencies?.length; else noDependenciesFound">
    <p>
      <span translate="parameters/whatsapp-templates/details/scenarios-dependencies/dependencies-found"></span>
    </p>
    <li *ngFor="let dependency of scenariosDependencies">
      <a [href]="dependency.url" rel="noopener noreferrer" target="_blank">{{ dependency.name }}</a>
    </li>
  </div>
  <ng-template #noDependenciesFound>
    <p class="description-link">
      <a [href]="scenarioListUrl" rel="noopener noreferrer" target="_blank">
        {{
          'parameters/whatsapp-templates/details/scenarios-dependencies/no-dependencies-found' | translate
        }}&nbsp;<mat-icon>open_in_new</mat-icon>
      </a>
    </p>
  </ng-template>
</ng-container>
